import React from 'react';
import SingleTeamMember from './SingleTeamMember';

function TeamMembersArea({ members,team }) {
  return (
    <section className="team-area mt-5">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="third-section-title text-center mb-60">
              <h2>
                MEET <span>OUR</span> TEAM
              </h2>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          {members&&members?.map(( member ) => (
            <SingleTeamMember member={member} team={team} key={member?.playerAddress}/>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TeamMembersArea;
